import BaseFetchRequest from '@r1-frontend/do-request/core/BaseFetchRequest';
import { DoRequest } from '@r1-frontend/do-request/core/DoRequest';

export const doFetchRequest = new DoRequest(
    new BaseFetchRequest(),
);
